(function($){
    var util = {
        api_to_page: function(the_api){
            var api_split = the_api.split('.');
            return {module:api_split[0],page:api_split[1]};
        },
        standard_opts: function(opts) {
            var defaults = {
                success:false,
                error:false,
                type:'GET',
                timeout:30000
            };

            if (typeof opts == 'undefined') {
                opts = defaults;
            } else {
                for (var default_opt in defaults) {
                    if (defaults.hasOwnProperty(default_opt)) {
                        if (typeof opts[default_opt] == 'undefined') {
                            opts[default_opt] = defaults[default_opt];
                        }
                    }
                }
            }
            return opts;
        },
        wrap_func: function (func, check_json) {
            return function () {
                var args = Array.prototype.slice.call(arguments);
                if (check_json) {
                    // ensure valid json object if api.json was called
                    // and if it's a string, test if it parses as JSON. if it doesn't parse, it's not valid, so just bail
                    if (typeof args != 'undefined' && args && args[0]) {
                        if (typeof args[0] === 'string') {
                            var json_test;
                            try {
                                json_test = $.parseJSON(args[0]);
                            } catch (e) {
                                return;
                            }
                            // if the string parsed as valid json, set that object to args[0]
                            args[0] = json_test;
                        }
                    }
                }

                if (typeof args != 'undefined' && args && args[0] && args[0].hasOwnProperty('logout_redirect')) {
                    window.location.href = args[0].logout_redirect;
                    return;
                }
                return func.apply(this, args);
            };
        }
    };

    var fetch = {
        url: '/members/%module%/%page%/',
        go: function(the_api, opts, check_json){
            if (typeof the_api == 'undefined') {
                return;
            }

            var api, request_path;

            // scrub leading //www.host.name that choke ajax reqs (generated in util.php => clean_url())
            the_api = (the_api) ? the_api.replace('//'+window.location.host,'') : the_api;
            if (opts.no_parse_url || the_api.indexOf('.') === -1) {
                request_path = the_api;
            } else {
                api = util.api_to_page(the_api);
                request_path = fetch.url.replace('%module%',api.module).replace('%page%',api.page);
            }

            // if we are passing in a success callback function (most likely will)
            // lets wrap it and check for logout_redirect before calling the provided success callback
            if (typeof opts.success == 'function') {
                opts.success = util.wrap_func(opts.success, check_json);
            }

            // ensure we have a handler
            if (typeof opts.success == 'function' && opts.error === false) {
                opts.error = opts.success;
            } else if (opts.success === false) {
                opts.success = opts.error = function(response) { /*nadda*/ };
            }

            return $.ajax(request_path,opts);
        },
        get: function(api, options){
            var opts = util.standard_opts(options);
            return fetch.go(api, opts);
        },
        post: function(api, options){
            var opts = util.standard_opts(options);
            opts.type = 'POST';
            return fetch.go(api, opts);
        },
        json: function(api, options){
            var opts = util.standard_opts(options);

            // passing true to fetch.go here because we are going to let jquery try to guess the return type
            // however require a json response by inspecting the response and trying to parse ourself if it's a string
            return fetch.go(api, opts, true);
        },
        html: function(api, options){
            var opts = util.standard_opts(options);
            opts.dataType = 'HTML';
            return fetch.go(api, opts);
        }
    };

    // add CSRF token to data sent for POST requests
    $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        var is_post = !!(originalOptions.type === 'POST' || options.type === 'POST');
        var csrf    = (GP.sdata.my_user && GP.sdata.my_user.csrf)? GP.sdata.my_user.csrf : false;
         
        if (is_post && csrf) {
            jqXHR.setRequestHeader("X-CSRF-Token", csrf);
        }
    });

    // hook us into Marionette for sharing
    var expose = "get post json html".split(' ');
    for (var i=0; i<expose.length; i++) {
        Marionette.Application.prototype.api[expose[i]] = fetch[expose[i]];
    }
})(jQuery);
